/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @version 1.0.1
 * @since 1.0.1
 */

import IWidgetPaymentHistoryTranslation from '../../../types/pages/dashboard/widgetPaymentHistory';

const initTranslationWidgetPaymentHistory: IWidgetPaymentHistoryTranslation = {
    empty: {
        helpText: '',
        title: '',
    },
    fail: {
        text: '',
    },
    successful: {
        btnText: '',
    },
    title: '',
};

export default initTranslationWidgetPaymentHistory;
